<template>
  <b-card class="mb-2" no-body>
    <b-card-header>
      <b-row align-v="center">
        <b-col cols="auto" class="mr-auto">
          <h5 class="">Работы</h5>
        </b-col>
        <b-col cols="auto">
          <b-button size="sm" variant="success" @click.stop="onAdd()" :disabled="isDisabled">
            <font-awesome-icon icon="plus" class="mr-1"/>
            Добавить
          </b-button>
        </b-col>
      </b-row>
    </b-card-header>

    <b-table
      id="location-works"
      ref="location_works"
      class="mb-0"
      striped
      small
      thead-class="top-fixed-thead thead-light"
      table-class="text-small"
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy.sync="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-compare="sortCompare"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка</strong>
        </div>
      </template>
      <template #cell(work_type)="row">
        <work-type-select
          id="work-type-select"
          ref="work_type_select"
          :is-disabled = "isDisabled"
          v-on:onSelect="onSelectWorkType($event, row)"
          v-bind:id = row.item.work_type_id
         />
      </template>

      <template #cell(rate)="row">
        <b-form-input
          id="input-rate"
          size="sm"
          :disabled="isDisabled"
          autocomplete="off"
          type="number"
          v-model.number="row.item.rate">
        </b-form-input>
      </template>

      <template #cell(unit)="row">
        <unit-select
          id="input-unit"
          ref="unit_select"
          :is-disabled = "isDisabled"
          :initial-unit="row.item.unit_code"
          is-short v-on:selectUnit="onSelectUnit($event, row)" />
      </template>

      <template #cell(action)="row">
        <b-button
          variant="danger"
          size="sm"
          :disabled="isDisabled"
          @click="onRemove(row)"
        >
          <font-awesome-icon icon="trash" />
        </b-button>
      </template>
    </b-table>

    <b-card-footer footer-bg-variant="light">
      <b-row align-h="between" align-v="center">
        <b-col cols="auto" class="mr-auto">
          Всего записей: <b>{{items.length}}</b>
        </b-col>
        <b-col cols="auto">
          <b-pagination
            id="location-works-pagination"
            pills
            :total-rows="items.length"
            :per-page="perPage"
            v-model="currentPage"/>
        </b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>

<script>
import helpers from "../../utilites/helpers";
  import WorkTypeSelect from "../Catalogs/WorkType/WorkTypeSelect";
  import UnitSelect from "../Catalogs/UnitSelect";

export default {
  name: "LocationWorks",
  components: { WorkTypeSelect, UnitSelect },
  mixins: [ helpers ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      locationId: 0,
      isBusy: false,
      items: [],
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          key: 'work_type',
          label: 'Вид работ',
          sortable: false
        },
        {
          key: 'rate',
          label: 'Стоимость работ',
          sortable: false
        },
        {
          key: 'unit',
          label: 'Ед. изм.',
          sortable: false
        },
        {
          key: 'action',
          label: "Действия",
          class: 'location-works-action',
          tdClass: 'align-bottom',
          sortable: false
        },
      ],
      deleteRow: {
        id: null,
        work_type_name: ''
      },
      sortBy: 'id',
      sortDesc: true,
    }
  },
  methods: {
    configure(locationId, items) {
      this.items = items;
      this.locationId = locationId;
    },
    onAdd() {
      const data = {
        id: 0,
        work_type_id: 0,
        work_type_name: '',
        rate: 0,
        unit_code: '539',
      };
      this.items.unshift(data);
      this.currentPage = 1;
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление работы";
      const message = `Вы уверены, что хотите удалить ${this.deleteRow.work_type_name.toLowerCase()}?`;
      this.showModalDelete(title, message, function () {
        const index = this.items.findIndex(item => item === row.item);
        this.items.splice(index, 1);
      }.bind(this));
    },
    onSelectWorkType(workType, row) {
      if (workType != null) {
        row.item.work_type_id = workType.id;
        row.item.work_type_name = workType.name;
      } else {
        row.item.work_type_id = 0;
        row.item.work_type_name = "";
      }
    },
    // Единицы измерения
    onSelectUnit(unit, row) {
      row.item.unit_code = unit.code;
    },
  }
}
</script>

<style >
.location-works-action {
  width: 80px;
}

#location-works td {
  text-align: center;
}

#location-works th {
  text-align: center;
  vertical-align: middle;
}

#location-works-pagination {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationWorks.vue